var _style, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNorseLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1194 620",
    style: {
      enableBackground: "new 0 0 1194 620"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000053503011538773896030000016404565844448598203_);fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 54.2,
    y: 98.4,
    width: 1088.8,
    height: 424.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072258254190509469630000010878805571495710638_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    d: "M514.4,386.9L445,296.8 c-1.9-2.8-3.7-5.7-3.9-6.1c0,0.2,0.4,4,0.4,7.6v88.6H407V232.2h29.7l69.5,89.2c2.2,2.8,3.7,5.7,3.9,6.4c0-0.2-0.4-4-0.4-7.8v-87.8 h34.5v154.7H514.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    d: "M847.4,386.9 l-43.8-73.1v73.1h-34.5V232.2h56.5c33,0,54.1,19.5,54.1,46.2c0,23.1-14.4,38.4-35.1,43.9l41.8,64.6H847.4z M825.6,260.8h-22v37.3 h22c12.1,0,19.6-7.6,19.6-19.7C845.3,267.6,836.6,260.8,825.6,260.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    d: "M963.5,390.9 c-21.8,0-37.7-7.8-52.8-19.3l17.9-23.7c9.3,7.2,22.7,13.3,35.6,13.3c15.7,0,20.1-5.3,20.1-14.6c0-15.5-28.7-20.8-41.9-28 c-15.7-8.5-28.3-18.2-28.3-42.8c0-31.8,28.3-44.7,56.1-44.7c14.9,0,32.8,4,45.5,13.3l-15.5,25.2c-6.9-5.1-18.5-8.9-30-8.9 c-16,0-21.6,8.9-21.6,15.1c0,14,20.1,18.2,38.4,26.1c15.3,6.6,31.7,17.2,31.7,42.6C1018.7,373.7,997.6,390.9,963.5,390.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    points: "1048.2,385.8  1048.2,231.1 1139.9,231.1 1139.9,259.7 1082.7,259.7 1082.7,296 1135.7,296 1135.7,324.6 1082.7,324.6 1082.7,357.2 1143.1,357.2  1143.1,385.8  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    d: "M75.1,566.9 c-0.5,0.9-1.1,1.6-2,2.2c-0.8,0.6-1.8,1.1-2.9,1.5c-1.1,0.4-2.3,0.5-3.6,0.5h-8.5v11h-3.4v-28.6h11.9c1.3,0,2.5,0.2,3.6,0.5 c1.1,0.4,2.1,0.9,2.9,1.5c0.8,0.6,1.5,1.4,2,2.3c0.5,0.9,0.7,1.8,0.7,2.7v3.6C75.9,565.1,75.6,566,75.1,566.9 M72.5,560.6 c0-0.6-0.2-1.2-0.5-1.8c-0.3-0.5-0.7-1-1.3-1.5c-0.5-0.4-1.2-0.8-1.9-1c-0.7-0.2-1.5-0.4-2.3-0.4h-8.4v12.7h8.4 c0.8,0,1.6-0.1,2.3-0.4c0.7-0.2,1.4-0.6,1.9-1c0.6-0.4,1-0.9,1.3-1.5c0.3-0.5,0.5-1.1,0.5-1.8V560.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    d: "M132.1,582.1 l-10.2-12.2h-4.6v12.2h-3.4v-28.6h11.9c1.3,0,2.5,0.2,3.6,0.5c1.1,0.4,2.1,0.9,2.9,1.5c0.8,0.6,1.5,1.4,2,2.3 c0.5,0.9,0.7,1.8,0.7,2.7v2.3c0,1-0.2,1.9-0.7,2.7c-0.5,0.9-1.1,1.6-2,2.2c-0.8,0.6-1.8,1.1-2.9,1.5c-1.1,0.4-2.3,0.5-3.6,0.5 l10.2,12.2H132.1z M131.7,560.6c0-0.6-0.2-1.2-0.5-1.8c-0.3-0.5-0.7-1-1.3-1.5c-0.5-0.4-1.2-0.8-1.9-1c-0.7-0.2-1.5-0.4-2.3-0.4 h-8.4v11.5h8.4c0.8,0,1.6-0.1,2.3-0.4c0.7-0.2,1.4-0.6,1.9-1c0.5-0.4,1-0.9,1.3-1.5c0.3-0.5,0.5-1.1,0.5-1.8V560.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    d: "M194.5,578.2 c-0.5,0.9-1.1,1.6-2,2.2c-0.8,0.6-1.8,1.1-2.9,1.5c-1.1,0.4-2.3,0.6-3.6,0.6h-2.7c-1.3,0-2.5-0.2-3.6-0.6c-1.1-0.4-2.1-0.9-2.9-1.5 c-0.8-0.7-1.5-1.4-2-2.2c-0.5-0.8-0.7-1.8-0.7-2.7v-15.4c0-1,0.2-1.9,0.7-2.7c0.5-0.9,1.1-1.6,2-2.2c0.8-0.6,1.8-1.1,2.9-1.5 c1.1-0.4,2.3-0.5,3.6-0.5h2.7c1.3,0,2.5,0.2,3.6,0.5c1.1,0.4,2.1,0.9,2.9,1.5c0.8,0.6,1.5,1.4,2,2.2c0.5,0.8,0.7,1.8,0.7,2.7v15.4 C195.2,576.5,195,577.4,194.5,578.2 M191.8,560.2c0-0.6-0.2-1.2-0.5-1.8c-0.3-0.6-0.7-1-1.3-1.4c-0.5-0.4-1.2-0.7-1.9-1 c-0.7-0.2-1.5-0.4-2.3-0.4h-2.4c-0.8,0-1.6,0.1-2.3,0.4c-0.7,0.2-1.4,0.6-1.9,1c-0.6,0.4-1,0.9-1.3,1.4c-0.3,0.5-0.5,1.1-0.5,1.8 v15.4c0,0.6,0.2,1.2,0.5,1.8c0.3,0.6,0.7,1,1.3,1.5c0.6,0.4,1.2,0.7,1.9,1c0.7,0.2,1.5,0.4,2.3,0.4h2.4c0.8,0,1.6-0.1,2.3-0.4 c0.7-0.2,1.4-0.6,1.9-1c0.5-0.4,1-0.9,1.3-1.5c0.3-0.5,0.5-1.2,0.5-1.8V560.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    d: "M255.9,566.9 c-0.5,0.9-1.1,1.6-2,2.2c-0.8,0.6-1.8,1.1-3,1.5c-1.1,0.4-2.3,0.5-3.6,0.5h-8.5v11h-3.4v-28.6h11.9c1.3,0,2.5,0.2,3.6,0.5 c1.1,0.4,2.1,0.9,3,1.5c0.8,0.6,1.5,1.4,2,2.3c0.5,0.9,0.7,1.8,0.7,2.7v3.6C256.6,565.1,256.4,566,255.9,566.9 M253.2,560.6 c0-0.6-0.2-1.2-0.5-1.8c-0.3-0.5-0.7-1-1.3-1.5c-0.5-0.4-1.2-0.8-1.9-1c-0.7-0.2-1.5-0.4-2.3-0.4h-8.3v12.7h8.3 c0.8,0,1.6-0.1,2.3-0.4c0.7-0.2,1.4-0.6,1.9-1c0.6-0.4,1-0.9,1.3-1.5c0.3-0.5,0.5-1.1,0.5-1.8V560.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    points: "295.2,582.1  295.2,553.5 316.3,553.5 316.3,556 298.6,556 298.6,566.6 313,566.6 313,569.1 298.6,569.1 298.6,579.7 316.3,579.7 316.3,582.1  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    d: "M372.6,582.1 l-10.2-12.2h-4.6v12.2h-3.4v-28.6h11.9c1.3,0,2.5,0.2,3.6,0.5c1.1,0.4,2.1,0.9,2.9,1.5c0.8,0.6,1.5,1.4,2,2.3 c0.5,0.9,0.7,1.8,0.7,2.7v2.3c0,1-0.2,1.9-0.7,2.7c-0.5,0.9-1.1,1.6-2,2.2c-0.8,0.6-1.8,1.1-2.9,1.5c-1.1,0.4-2.3,0.5-3.6,0.5 l10.2,12.2H372.6z M372.2,560.6c0-0.6-0.2-1.2-0.5-1.8c-0.3-0.5-0.7-1-1.3-1.5c-0.5-0.4-1.2-0.8-1.9-1c-0.7-0.2-1.5-0.4-2.3-0.4 h-8.4v11.5h8.4c0.8,0,1.6-0.1,2.3-0.4c0.7-0.2,1.4-0.6,1.9-1c0.5-0.4,1-0.9,1.3-1.5c0.3-0.5,0.5-1.1,0.5-1.8V560.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    points: "424.2,556  424.2,582.1 420.9,582.1 420.9,556 411.9,556 411.9,553.5 433.2,553.5 433.2,556  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    points: "480.6,568.5  480.6,582.1 477.2,582.1 477.2,568.5 467.5,553.5 471.2,553.5 478.9,565.4 486.6,553.5 490.3,553.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    points: "595.4,582.1  595.4,562.5 595.2,563.7 586.5,582.1 584.7,582.1 575.9,563.7 575.7,562.5 575.7,582.1 572.3,582.1 572.3,553.5 574.1,553.5  585.5,577 585.6,578 585.7,577 597,553.5 598.8,553.5 598.8,582.1  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    d: "M653.6,575.5h-11.9 l-2.5,6.7h-3.5l11-28.6h1.8l11.1,28.6h-3.5L653.6,575.5z M642.7,573h10.1l-4.9-13.2l-0.1-1.1l-0.1,1.1L642.7,573z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    points: "716,582.1  700.3,561.3 700,560.1 700,582.1 696.6,582.1 696.6,553.5 698.4,553.5 714,574.4 714.4,575.6 714.4,553.5 717.7,553.5 717.7,582.1  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    d: "M772.6,575.5h-11.9 l-2.5,6.7h-3.5l11-28.6h1.8l11.1,28.6h-3.5L772.6,575.5z M761.6,573h10.1l-4.9-13.2l-0.1-1.1l-0.1,1.1L761.6,573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    d: "M836.1,582.1h-1.1 l-2-2.3c-0.8,0.8-1.8,1.5-3,2c-1.2,0.5-2.5,0.7-3.9,0.7h-2c-1.3,0-2.5-0.2-3.6-0.5c-1.1-0.4-2.1-0.9-3-1.5c-0.8-0.6-1.5-1.4-2-2.2 c-0.5-0.9-0.7-1.8-0.7-2.7v-15.4c0-1,0.2-1.9,0.7-2.7c0.5-0.9,1.1-1.6,2-2.2c0.8-0.6,1.8-1.1,3-1.5c1.1-0.4,2.3-0.5,3.6-0.5h2.7 c1.3,0,2.5,0.2,3.6,0.5c1.1,0.4,2.1,0.9,2.9,1.5c0.9,0.6,1.5,1.4,2,2.2c0.5,0.8,0.7,1.8,0.7,2.7v1.2l-3.4,0.4v-1.6 c0-0.6-0.2-1.2-0.5-1.8c-0.3-0.6-0.7-1-1.3-1.4c-0.5-0.4-1.2-0.7-1.9-1c-0.7-0.2-1.5-0.4-2.3-0.4h-2.4c-0.8,0-1.6,0.1-2.4,0.4 c-0.7,0.2-1.4,0.6-1.9,1c-0.6,0.4-1,0.9-1.3,1.4c-0.3,0.5-0.5,1.1-0.5,1.8v15.4c0,0.6,0.2,1.2,0.5,1.8c0.3,0.5,0.7,1,1.3,1.5 c0.5,0.4,1.2,0.7,1.9,1c0.7,0.2,1.5,0.4,2.4,0.4h2.4c0.8,0,1.6-0.1,2.3-0.4c0.7-0.2,1.4-0.6,1.9-1c0.6-0.4,1-0.9,1.3-1.5 c0.3-0.6,0.5-1.2,0.5-1.8v-6h-6v-2.4h9.4V582.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    points: "876.4,582.1  876.4,553.5 897.5,553.5 897.5,556 879.8,556 879.8,566.6 894.1,566.6 894.1,569.1 879.8,569.1 879.8,579.7 897.5,579.7  897.5,582.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    points: "959.3,582.1  959.3,562.5 959,563.7 950.3,582.1 948.5,582.1 939.7,563.7 939.5,562.5 939.5,582.1 936.1,582.1 936.1,553.5 937.9,553.5  949.3,577 949.4,578 949.5,577 960.9,553.5 962.6,553.5 962.6,582.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    points: "1003.4,582.1  1003.4,553.5 1024.5,553.5 1024.5,556 1006.8,556 1006.8,566.6 1021.1,566.6 1021.1,569.1 1006.8,569.1 1006.8,579.7 1024.5,579.7  1024.5,582.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    points: "1082.5,582.1  1066.8,561.3 1066.5,560.1 1066.5,582.1 1063.1,582.1 1063.1,553.5 1064.9,553.5 1080.5,574.4 1080.9,575.6 1080.9,553.5  1084.3,553.5 1084.3,582.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    points: "1134.1,556  1134.1,582.1 1130.8,582.1 1130.8,556 1121.8,556 1121.8,553.5 1143.1,553.5 1143.1,556  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    d: "M655.5,387.9 c-48.8,0-80.9-36.5-80.9-80.5c0-44.5,32.6-79.3,81.3-79.3c49.2,0,80.9,33.3,80.9,79.3C736.8,352,704.2,387.9,655.5,387.9  M655.9,257.7c-27,0-45.7,23.7-45.7,49.6c0,28.4,20.7,50.9,45.3,50.9c28.5,0,45.7-24.8,45.7-50.9 C701.2,280.2,683.3,257.7,655.9,257.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    d: "M75.1,566.9 c-0.5,0.9-1.1,1.6-2,2.2c-0.8,0.6-1.8,1.1-2.9,1.5c-1.1,0.4-2.3,0.5-3.6,0.5h-8.5v11h-3.4v-28.6h11.9c1.3,0,2.5,0.2,3.6,0.5 c1.1,0.4,2.1,0.9,2.9,1.5c0.8,0.6,1.5,1.4,2,2.3c0.5,0.9,0.7,1.8,0.7,2.7v3.6C75.9,565.1,75.6,566,75.1,566.9 M72.5,560.6 c0-0.6-0.2-1.2-0.5-1.8c-0.3-0.5-0.7-1-1.3-1.5c-0.5-0.4-1.2-0.8-1.9-1c-0.7-0.2-1.5-0.4-2.3-0.4h-8.4v12.7h8.4 c0.8,0,1.6-0.1,2.3-0.4c0.7-0.2,1.4-0.6,1.9-1c0.6-0.4,1-0.9,1.3-1.5c0.3-0.5,0.5-1.1,0.5-1.8V560.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    d: "M132.1,582.1 l-10.2-12.2h-4.6v12.2h-3.4v-28.6h11.9c1.3,0,2.5,0.2,3.6,0.5c1.1,0.4,2.1,0.9,2.9,1.5c0.8,0.6,1.5,1.4,2,2.3 c0.5,0.9,0.7,1.8,0.7,2.7v2.3c0,1-0.2,1.9-0.7,2.7c-0.5,0.9-1.1,1.6-2,2.2c-0.8,0.6-1.8,1.1-2.9,1.5c-1.1,0.4-2.3,0.5-3.6,0.5 l10.2,12.2H132.1z M131.7,560.6c0-0.6-0.2-1.2-0.5-1.8c-0.3-0.5-0.7-1-1.3-1.5c-0.5-0.4-1.2-0.8-1.9-1c-0.7-0.2-1.5-0.4-2.3-0.4 h-8.4v11.5h8.4c0.8,0,1.6-0.1,2.3-0.4c0.7-0.2,1.4-0.6,1.9-1c0.5-0.4,1-0.9,1.3-1.5c0.3-0.5,0.5-1.1,0.5-1.8V560.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    d: "M194.5,578.2 c-0.5,0.9-1.1,1.6-2,2.2c-0.8,0.6-1.8,1.1-2.9,1.5c-1.1,0.4-2.3,0.6-3.6,0.6h-2.7c-1.3,0-2.5-0.2-3.6-0.6c-1.1-0.4-2.1-0.9-2.9-1.5 c-0.8-0.7-1.5-1.4-2-2.2c-0.5-0.8-0.7-1.8-0.7-2.7v-15.4c0-1,0.2-1.9,0.7-2.7c0.5-0.9,1.1-1.6,2-2.2c0.8-0.6,1.8-1.1,2.9-1.5 c1.1-0.4,2.3-0.5,3.6-0.5h2.7c1.3,0,2.5,0.2,3.6,0.5c1.1,0.4,2.1,0.9,2.9,1.5c0.8,0.6,1.5,1.4,2,2.2c0.5,0.8,0.7,1.8,0.7,2.7v15.4 C195.2,576.5,195,577.4,194.5,578.2 M191.8,560.2c0-0.6-0.2-1.2-0.5-1.8c-0.3-0.6-0.7-1-1.3-1.4c-0.5-0.4-1.2-0.7-1.9-1 c-0.7-0.2-1.5-0.4-2.3-0.4h-2.4c-0.8,0-1.6,0.1-2.3,0.4c-0.7,0.2-1.4,0.6-1.9,1c-0.6,0.4-1,0.9-1.3,1.4c-0.3,0.5-0.5,1.1-0.5,1.8 v15.4c0,0.6,0.2,1.2,0.5,1.8c0.3,0.6,0.7,1,1.3,1.5c0.6,0.4,1.2,0.7,1.9,1c0.7,0.2,1.5,0.4,2.3,0.4h2.4c0.8,0,1.6-0.1,2.3-0.4 c0.7-0.2,1.4-0.6,1.9-1c0.5-0.4,1-0.9,1.3-1.5c0.3-0.5,0.5-1.2,0.5-1.8V560.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    d: "M255.9,566.9 c-0.5,0.9-1.1,1.6-2,2.2c-0.8,0.6-1.8,1.1-3,1.5c-1.1,0.4-2.3,0.5-3.6,0.5h-8.5v11h-3.4v-28.6h11.9c1.3,0,2.5,0.2,3.6,0.5 c1.1,0.4,2.1,0.9,3,1.5c0.8,0.6,1.5,1.4,2,2.3c0.5,0.9,0.7,1.8,0.7,2.7v3.6C256.6,565.1,256.4,566,255.9,566.9 M253.2,560.6 c0-0.6-0.2-1.2-0.5-1.8c-0.3-0.5-0.7-1-1.3-1.5c-0.5-0.4-1.2-0.8-1.9-1c-0.7-0.2-1.5-0.4-2.3-0.4h-8.3v12.7h8.3 c0.8,0,1.6-0.1,2.3-0.4c0.7-0.2,1.4-0.6,1.9-1c0.6-0.4,1-0.9,1.3-1.5c0.3-0.5,0.5-1.1,0.5-1.8V560.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    points: "295.2,582.1  295.2,553.5 316.3,553.5 316.3,556 298.6,556 298.6,566.6 313,566.6 313,569.1 298.6,569.1 298.6,579.7 316.3,579.7 316.3,582.1  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    d: "M372.6,582.1 l-10.2-12.2h-4.6v12.2h-3.4v-28.6h11.9c1.3,0,2.5,0.2,3.6,0.5c1.1,0.4,2.1,0.9,2.9,1.5c0.8,0.6,1.5,1.4,2,2.3 c0.5,0.9,0.7,1.8,0.7,2.7v2.3c0,1-0.2,1.9-0.7,2.7c-0.5,0.9-1.1,1.6-2,2.2c-0.8,0.6-1.8,1.1-2.9,1.5c-1.1,0.4-2.3,0.5-3.6,0.5 l10.2,12.2H372.6z M372.2,560.6c0-0.6-0.2-1.2-0.5-1.8c-0.3-0.5-0.7-1-1.3-1.5c-0.5-0.4-1.2-0.8-1.9-1c-0.7-0.2-1.5-0.4-2.3-0.4 h-8.4v11.5h8.4c0.8,0,1.6-0.1,2.3-0.4c0.7-0.2,1.4-0.6,1.9-1c0.5-0.4,1-0.9,1.3-1.5c0.3-0.5,0.5-1.1,0.5-1.8V560.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    points: "424.2,556  424.2,582.1 420.9,582.1 420.9,556 411.9,556 411.9,553.5 433.2,553.5 433.2,556  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    points: "480.6,568.5  480.6,582.1 477.2,582.1 477.2,568.5 467.5,553.5 471.2,553.5 478.9,565.4 486.6,553.5 490.3,553.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    points: "595.4,582.1  595.4,562.5 595.2,563.7 586.5,582.1 584.7,582.1 575.9,563.7 575.7,562.5 575.7,582.1 572.3,582.1 572.3,553.5 574.1,553.5  585.5,577 585.6,578 585.7,577 597,553.5 598.8,553.5 598.8,582.1  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    d: "M653.6,575.5h-11.9 l-2.5,6.7h-3.5l11-28.6h1.8l11.1,28.6h-3.5L653.6,575.5z M642.7,573h10.1l-4.9-13.2l-0.1-1.1l-0.1,1.1L642.7,573z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    points: "716,582.1  700.3,561.3 700,560.1 700,582.1 696.6,582.1 696.6,553.5 698.4,553.5 714,574.4 714.4,575.6 714.4,553.5 717.7,553.5 717.7,582.1  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    d: "M772.6,575.5h-11.9 l-2.5,6.7h-3.5l11-28.6h1.8l11.1,28.6h-3.5L772.6,575.5z M761.6,573h10.1l-4.9-13.2l-0.1-1.1l-0.1,1.1L761.6,573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    d: "M836.1,582.1h-1.1 l-2-2.3c-0.8,0.8-1.8,1.5-3,2c-1.2,0.5-2.5,0.7-3.9,0.7h-2c-1.3,0-2.5-0.2-3.6-0.5c-1.1-0.4-2.1-0.9-3-1.5c-0.8-0.6-1.5-1.4-2-2.2 c-0.5-0.9-0.7-1.8-0.7-2.7v-15.4c0-1,0.2-1.9,0.7-2.7c0.5-0.9,1.1-1.6,2-2.2c0.8-0.6,1.8-1.1,3-1.5c1.1-0.4,2.3-0.5,3.6-0.5h2.7 c1.3,0,2.5,0.2,3.6,0.5c1.1,0.4,2.1,0.9,2.9,1.5c0.9,0.6,1.5,1.4,2,2.2c0.5,0.8,0.7,1.8,0.7,2.7v1.2l-3.4,0.4v-1.6 c0-0.6-0.2-1.2-0.5-1.8c-0.3-0.6-0.7-1-1.3-1.4c-0.5-0.4-1.2-0.7-1.9-1c-0.7-0.2-1.5-0.4-2.3-0.4h-2.4c-0.8,0-1.6,0.1-2.4,0.4 c-0.7,0.2-1.4,0.6-1.9,1c-0.6,0.4-1,0.9-1.3,1.4c-0.3,0.5-0.5,1.1-0.5,1.8v15.4c0,0.6,0.2,1.2,0.5,1.8c0.3,0.5,0.7,1,1.3,1.5 c0.5,0.4,1.2,0.7,1.9,1c0.7,0.2,1.5,0.4,2.4,0.4h2.4c0.8,0,1.6-0.1,2.3-0.4c0.7-0.2,1.4-0.6,1.9-1c0.6-0.4,1-0.9,1.3-1.5 c0.3-0.6,0.5-1.2,0.5-1.8v-6h-6v-2.4h9.4V582.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    points: "876.4,582.1  876.4,553.5 897.5,553.5 897.5,556 879.8,556 879.8,566.6 894.1,566.6 894.1,569.1 879.8,569.1 879.8,579.7 897.5,579.7  897.5,582.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    points: "959.3,582.1  959.3,562.5 959,563.7 950.3,582.1 948.5,582.1 939.7,563.7 939.5,562.5 939.5,582.1 936.1,582.1 936.1,553.5 937.9,553.5  949.3,577 949.4,578 949.5,577 960.9,553.5 962.6,553.5 962.6,582.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    points: "1003.4,582.1  1003.4,553.5 1024.5,553.5 1024.5,556 1006.8,556 1006.8,566.6 1021.1,566.6 1021.1,569.1 1006.8,569.1 1006.8,579.7 1024.5,579.7  1024.5,582.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    points: "1082.5,582.1  1066.8,561.3 1066.5,560.1 1066.5,582.1 1063.1,582.1 1063.1,553.5 1064.9,553.5 1080.5,574.4 1080.9,575.6 1080.9,553.5  1084.3,553.5 1084.3,582.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    points: "1134.1,556  1134.1,582.1 1130.8,582.1 1130.8,556 1121.8,556 1121.8,553.5 1143.1,553.5 1143.1,556  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 228,
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    width: 56.4,
    height: 292.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.6,
    y: 227.7,
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    width: 56.4,
    height: 163.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.5,
    y: 98.4,
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    width: 56.4,
    height: 292.5
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    points: "59.6,458.2  59.6,160.7 237.1,160.7 237.1,155.5 54.2,155.5 54.2,463.5 81,463.5 81,458.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000072258254190509469630000010878805571495710638_)",
      fill: "#FFFFFF"
    },
    points: "364.1,155.5  337.1,155.5 337.1,160.7 358.8,160.7 358.8,458.2 181.4,458.2 181.4,463.5 364.1,463.5  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorseLogoWhite);
export default __webpack_public_path__ + "static/media/norse-logo-white.d366b8f5.svg";
export { ForwardRef as ReactComponent };